import Bills from "./Bills";
export default function PurchaseOrders() {
    return <Bills docType="purchase_order" title="Purchase Orders" kicker="PURCHASES" subtitle="POs raised to vendors. Convert into bills when received." />;
}
